module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-5 pt-2"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('review-meeting-data-table', {
    attrs: {
      "refresh": _vm.isRefresh
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d8ccd8ac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/ReviewMeeting/index.vue
// module id = 2301
// module chunks = 0